import actions from "./moduleExportActions.js";
export default {
  namespaced: true,
  actions: actions,
};
